import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {

    getBills({ dispatch, commit }, data) {
        axios
            .get("Payment/Salary?date=" + data)
            .then((res) => {
                commit("setBills", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getParts({ dispatch, commit }) {
        axios
            .get("User/ListAsset")
            .then((res) => {
                commit("setParts", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getLoans({ dispatch, commit }) {
        axios
            .get("Payment/EmployeeLoan?Page=1&PageSize=10000")
            .then((res) => {
                commit("setLoans", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },

    getRewards({ dispatch, commit }) {
        axios
            .get("Payment/EmployeeReward?Page=1&PageSize=10000")
            .then((res) => {
                commit("setRewards", res.data.data.$values);
            })
            .catch((error) => {
                dispatch("errorGETHandler", error, { root: true });
            });
    },


};
